import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { NoDataFound } from '~/components/no-data-found/NoDataFound';

export const Wrapper = styled.div`
  display: block;
`;

export const WidgetTitle = styled.p`
  padding: 20px;
  ${typographyV2.titleMd};
`;

export const StyledNoDataFound = styled(NoDataFound)`
  > span {
    max-width: unset;
  }
`;
